module.exports = __webpack_public_path__ + "static/media/305.74de7a50.svg";